module.exports = __webpack_public_path__ + "img/knsu_gallery4.893bda46.jpg";